export enum StoreSignUpTestIds {
  COUNTRY_SELECT = 'store-sign-up-country-select',
  CNPJ_FIELD = 'store-sign-up-cnpj-field',
  CONTINUE_BUTTON = 'store-sign-up-continue-button',
  GO_TO_LOGIN_LINK = 'store-sign-up-go-to-login-link',
  BACK_TO_LOGIN_BUTTON = 'store-sign-up-back-to-login-button',
  HELP_BUTTON = 'store-sign-up-help-button',
  STORE_STEP_INTRO = 'store-sign-up-store-step-intro',
  WIZARD_CONTINUE_BUTTON = 'store-sign-up-wizard-continue-button',
  FINISH_REGISTRATION_BUTTON = 'store-sign-up-finish-registration-button',
  STORE_CNPJ = 'store-sign-up-store-cnpj',
  STORE_COMMERCIAL_NAME = 'store-sign-up-store-commercial-name',
  STORE_COMPANY_NAME = 'store-sign-up-store-company-name',
  STORE_STORE_EMAIL = 'store-sign-up-store-store-email',
  NEW_ACCOUNT_NAME = 'store-sign-up-new-account-name',
  NEW_ACCOUNT_SURNAME = 'store-sign-up-new-account-surname',
  NEW_ACCOUNT_EMAIL = 'store-sign-up-new-account-email',
  NEW_ACCOUNT_PASSWORD = 'store-sign-up-new-account-password',
  NEW_ACCOUNT_CONFIRM_PASSWORD = 'store-sign-up-new-account-confirm-password',
  EXISTENT_ACCOUNT_EMAIL = 'store-sign-up-existent-account-email',
  EXISTENT_ACCOUNT_PASSWORD = 'store-sign-up-existent-account-password',
}
